import { Actionable } from '@libero/api-client/actionable/types';
import { Contract } from '@libero/api-client/contract/types';
import { Media } from '@libero/api-client/media/types';
import type { Note } from '@libero/api-client/note/types';
import { Organisation } from '@libero/api-client/organisation/types';
import { PriceList } from '@libero/api-client/price-list/types';
import type { Relation } from '@libero/api-client/relation/types';
import { TermSheet } from '@libero/api-client/term-sheet/types';
import { TicketLeadTime } from '@libero/api-client/ticket-lead-times/types';
import { TicketStatus } from '@libero/api-client/ticket-status/types';
import { TicketSubject } from '@libero/api-client/ticket-subject/types';
import { TicketType } from '@libero/api-client/ticket-type/types';
import type { Resource } from '@libero/api-client/types/resource';
import { Money } from '@libero/types/Price';

export enum TicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export interface Ticket extends Resource {
  id: string;
  number: number;
  description: string;
  source?: string;
  ticket_type: TicketType;
  ticket_status: TicketStatus;
  ticket_subject?: TicketSubject;
  priority: TicketPriority;
  media: Media[];
  notes: Note[];
  relations: Relation[];
  container_ids: string[];
  container_names: string;
  containers_count?: number;
  ticket_ids: string[];
  ticket_status_achieved: Record<number, string>;
  actionable_type: string;
  actionable?: Actionable;
  contractor: Organisation | null;
  contract: Contract | null;
  term_sheet: TermSheet | null;
  price_list: PriceList | null;
  total_cost: Money;
  lead_times: TicketLeadTime[];
  city: string;
  public_space_name: string;
  location_note: string | null;
  e_safety: boolean;
  separate_term: boolean;
  is_completed: boolean;
  has_attention_value?: boolean;
  has_empty_container_causes?: boolean;
  started_at: string | null;
  expected_resolution_at: string | null;
}

export interface StoreTicketRequest {
  ticket_subject_id: number | null;
  ticket_type_id: number | null;
  priority: TicketPriority;
  containers: string[];
  tickets: string[];
  actionable_id: string | number | null;
  contractor_id: number | null;
  theme_id: number | null;
  city: string | null;
  public_space_name: string | null;
  location_note: string | null;
  description: string | null;
  e_safety: boolean;
  separate_term: boolean;
  created_at?: string | null;
  started_at?: string | null;
  expected_resolution_at: string | null;
}

export interface UpdateTicketRequest extends Partial<StoreTicketRequest> {
  ticket_status_id?: number | null;
  contract_id?: string | null;
}

export interface MergeTicketRequest {
  ticket_id: string | null;
}
